import { useTheme } from '@emotion/react'
import { Box, Rating, ToggleButton, ToggleButtonGroup, useMediaQuery } from "@mui/material";
import React, {  useEffect, useState } from "react";
import "./main.css"
// import Card from "./Card"
// import { useGetproductByNameQuery } from "../Redux/product";
import style from "./card.module.css"
import style2 from "../Header/header.module.css"
import { Button } from "@mui/material";
import   Modal  from "@mui/material/Modal";
// import   axios  from "axios";
export default function Main() {
    const [alignment, setAlignment] = React.useState('left');

    const handleAlignment = (
        event,newAlignment
    ) => {
    setAlignment(newAlignment);
  };
  const them = useTheme()

  const [open, setOpen] = useState(false);
    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    // const them=usethem()

    
    const allProducts="https://dummyjson.com/products"
    const menProducts=`https://dummyjson.com/products/search?q=phone`
    const womenProducts="products?populate=*&filters[category][$eq]=women"
    
    const [myData,setMyData]=useState([allProducts])
    
    const [data2,setData2]=useState([])
    const [onlydata,setonlyData]=useState([])
    
    // const {data}   =useGetproductByNameQuery("https://dummyjson.com/products")
//     

 async function getdata(){
  
  const data= await fetch("https://dummyjson.com/products").then(res=>res.json())
      setData2(data.products)
    }
    
    
    
    async function getonlyproduct(id){
       
      const onlyproduct= await fetch(`https://dummyjson.com/products/${id}`).then(res=>res.json())
      setonlyData(onlyproduct)
    }
    
    async function search(item){
       
      const onlyproduct= await fetch(`https://dummyjson.com/products${item}`).then(res=>res.json())
      setData2(onlyproduct.products)
    }
    
    const [categotry,setcategotry]=useState([])
    async function getgategory(item){
       
      const onlyproduct= await fetch(`https://dummyjson.com/products/categories`).then(res=>res.json())
      setcategotry(onlyproduct)
    }

   

    console.log(onlydata.images)


    const count=1
    useEffect(()=>{
      
      getdata()
      getgategory()
      
    },[count])
    

    
    return (
      <div style={{ background: them.palette.mode === "dark" ? "#111" : "#eee" }}>
      <div className="container mt-5" >
  
        <div className="  d-flex justify-content-around align-items-center flex-wrap "
        >
          <div
            className="box1 p-2">
            <h2>Selected Producted</h2>
            <p>All our new arrivials in a exclusive brand selection</p>
          </div>
  
  
          <div className="box2">
            <ToggleButtonGroup
              value={alignment}
              exclusive 
              onChange={handleAlignment}
              aria-label="text alignment"
            >
              <ToggleButton value="left" onClick={()=>{search("/")}} aria-label="left aligned" className="mybuttons" style={{color:them.palette.text.primary ,fontSize:"16px"}}>
                All Product
              </ToggleButton>
              <ToggleButton value="center" onClick={()=>{search("/search?q=laptop")}}   aria-label="centered aligned" className="mybuttons mx-3" style={{color:them.palette.text.primary,fontSize:"16px"}}>
              laptops
              </ToggleButton>
              
              <ToggleButton value="right" onClick={()=>{search("/search?q=women-bag")}} aria-label="right aligned" className="mybuttons " style={{color:them.palette.text.primary,fontSize:"16px"}}>
              Women Bag
              </ToggleButton>
              <ToggleButton value="" onClick={()=>{search("/search?q=top")}} aria-label="right aligned" className="mybuttons mx-3" style={{color:them.palette.text.primary,fontSize:"16px"}}>
              Top
              </ToggleButton>
            </ToggleButtonGroup>
          </div>
        </div>
        <div className="cardbox">
        {/* <Card/> */}
          
                
                  <div  className=''>
                    <div   className="d-flex justify-content-between  flex-wrap "  >
                  
                    {data2.map((item,index)=>{
                    return(
                                  
                              <div key={index} className={`card ${style.hover} overflow-hidden mt-4 col-lg-4 shadow`} style={{background:them.palette.mode==="dark"?"#333":"#fff", maxWidth:"350px" }}>
                                <div style={{height:"300px"}}>
                                  <img src={`${item.thumbnail}`}  className="card-img-top h-100" alt="..."/>
                                </div>
                                  <div className="card-body"  style={{color:them.palette.text.primary}}>
                                      <div className="d-flex justify-content-between align-items-center">
                                      <h5  className="card-title fs-2">{item.title}</h5>
                                      <p className="card-text text-danger fs-4 m-0">{item.price}$</p>
                                      </div>
                                      <p className="card-text">{item.description}</p>
                                  </div>
                                  <div className="card-footer d-flex justify-content-between align-items-center">
                                      <Button className='gap-1 '  onClick={((e)=>{handleOpen(); getonlyproduct(item.id)})}> <i className="fa-solid fa-cart-shopping fs-5"></i>Add To Card</Button>
        
                                      <Rating name="read-only" value={item.rating} precision={.1} readOnly />
                                  </div>
                              </div>)})}
                    </div>
      
                      
                            
                            
                            
                            
                  </div>
  
        </div>
      </div>
      <Modal
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="child-modal-title"
                                aria-describedby="child-modal-description"
                                sx={{display:"flex",justifyContent:"center",alignItems:"center"}}
                            >
                                <Box sx={{ ...style, width: {xs:"90%",md:650},background:them.palette.neutral.main}}>
                                <div className="card mb-3" style={{background:them.palette.neutral.main}}>
                                <Button onClick={handleClose} className={`position-absolute `} style={{right:"0px",color:them.palette.iconColor.main}}>
                                    <i className={`fa-solid  fa-xmark fs-4 p-1 ${style2.hoverButton}`}></i>
                                </Button>  
                                    <div className="d-flex"  style={{display:"flex"}}>
                                    {useMediaQuery("(max-width:600px)")===true ?
                                      
                                      
                                          <div style={{flexDirection:"column" ,height:"90%"}} className='shadow-lg'>
                                            
                                            
                                              <div className="" style={{width:"100%"}}>
                                                      <img src={onlydata.thumbnail} className="img-fluid rounded-start w-100 h-100"  alt="..."/>
                                              </div>
                                              <div className="" style={{color:them.palette.iconColor.main ,width:"100%"}} >
                                                  <div className="card-body" sx={{text:{xs:"center",sm:"left"}}} >
                                                      <h5 className="card-title fs-2 fw-bold " >{onlydata.title}</h5>
                                                      <p className="card-text text-danger fs-4 m-0">{onlydata.price}$</p>
                                                      <p>{onlydata.description}</p>
                                                      <div className="images" style={{display:"flex",gap:"5px" ,width:"100px"}} >
                                                        
                                                          
                                                          {/* <img src={onlydata.images.index(0)} alt=""  className='w-100'/> */}
                                                          {/* <img src={onlydata.images[3]} alt=""  className='w-100'/>
                                                          <img src={onlydata.images[4]} alt=""  className='w-100'/> */}
                                                          
                                                      </div>
                                                      <div style={{display:"flex",justifyContent:"center"}}> 
                                                          <Button className="bg-primary mt-2 d-block"  style={{color:them.palette.iconColor.main,} }><i className="fa-solid fa-cart-shopping fs-5"></i> Buy Now</Button>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div >

                                        

                                      
                                    :
                                      
                                        
                                          <div className='shadow-lg d-flex' >
                                          <div  style={{width:"37%"}} >
                                                  <img src={onlydata.thumbnail} className="img-fluid rounded-start w-100 h-100"  alt="..."/>
                                              </div>
                                              <div className="" style={{color:them.palette.iconColor.main ,width:"63%"}} >
                                                  <div className="card-body" sx={{text:{xs:"center",sm:"left"}}} >
                                                      <h5 className="card-title fs-2 fw-bold " >{onlydata.title}</h5>
                                                      <p className="card-text text-danger fs-4 m-0">{onlydata.price}$</p>
                                                      <p>{onlydata.description}</p>
                                                      <div className="images" style={{display:"flex",gap:"5px" ,width:"100px"}} >
                                                        
                                                          {/* <img src={onlydata.images} alt="" className='w-100' />
                                                          <img src={onlydata.images} alt="" className='w-100' />
                                                          <img src={onlydata.images} alt="" className='w-100' /> */}
                                                      </div>
                                                      <div style={{display:"flex",justifyContent:"center"}}>
                                                          <Button className="bg-primary mt-2 d-block"  style={{color:them.palette.iconColor.main,} }><i className="fa-solid fa-cart-shopping fs-5"></i> Buy Now</Button>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>

                                          
                                          
                                      
                                    
                                    } 
                                        
                                    </div>
                                </div>
                                    
                                    
                                </Box>
      </Modal>
      
      </div>
    );
    
}
